import { Global } from "./global";
import Home from "./home";
import Partners from "./partners";
import Product from "./product";

(function () {
	let activeClass;

	const wrapper = document.querySelector("article");

	new Global();

	if (wrapper.dataset.dynmotorsTemplate == "home") {
		activeClass = new Home();
		return false;
	}

	if (wrapper.dataset.dynmotorsTemplate == "product") {
		activeClass = new Product();
		return false;
	}

	if (wrapper.dataset.dynmotorsTemplate == "partners") {
		activeClass = new Partners();
		return false;
	}

	activeClass = false;
})();
